// prevents input numbers from incremeting/decrementing on scroll
export const handleOnWheelEventForInputNumbers = (event) => {
  event.target.blur();
};
